import React from 'react';
import Styled from './NoResults.styles';

const NoResults = ({ children }) => {
  return <Styled.NoResults>{children}</Styled.NoResults>;
};

export default NoResults;
